import { Inject, Options, Vue } from "vue-property-decorator";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { TABreachView } from "@/shared/modules/typescript-trust-ti-api-client/models";
import { orderBy } from "lodash";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import { TrustAPI } from "@/shared/modules/trust-api";

@Options({
  props: {
    breaches: Array,
  },
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  },
  emits: ['update:breaches', 'close', 'addBreaches'],
})
export default class AddBreachesModal extends Vue {
  private breaches!: any[];

  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private isLoading = false;
  private errorLoadingData = false;

  private submitting = false;
  private searchKeyword = "";
  private breachesList: TABreachView[] = [];
  private breachesListDisplay: any[] = [];

  private showRuleBreachesOnly = true;
  private showLawBreachesOnly = true;
  private sortMethod = 'desc';
  private activeSortHeader = 1;

  private loadingContent = false;
  private errorLoadingContent = false;

  private tableHeadings = [
    { text: 'Type', value: 'breachType', sortable: false, sortMethod: 'asc' },
    { text: 'Breach code', value: 'breachCode', sortable: true, sortMethod: 'acs' },
    { text: 'Legislation', value: 'legislation', sortable: true, sortMethod: 'asc' },
    { text: 'Description', value: 'description', sortable: false, sortMethod: 'acs' },
    { text: 'Action', value: '', sortable: false, sortMethod: 'acs' },
  ]

  mounted(): void {
    this.preloadData();
  }

  private async preloadData(): Promise<void> {
    this.loadingContent = true;
    const _body = {
      keyword: '',
      ruleBreaches: true,
      lawBreaches: true
    }

    await this.apiService.CodeApi?.apiV2CodeGetBreachesPost()
      .then(res => {
        this.breachesList = res.data.data;
        this.breachesListDisplay = this.breachesList;
        for (let b = 0; b < this.breachesList.length; b++) {
          this.breachesListDisplay[b].type = this.breachesList[b].breachType.name;
          this.breachesListDisplay[b].isSelected = false;
        }
        // set existing breaches to selected
        if (this.breaches != null && this.breaches.length > 0) {
          for (let i = 0; i < this.breaches.length; i++) {
            const _b = this.breachesListDisplay.filter((b: any) => {
              return b.id == this.breaches[i].id;
            })
            if (_b.length > 0) {
              _b[0].isSelected = true;
            }
          }
        }
        // this.sortTableColumn(this.activeSortHeader, true);
        this.loadingContent = false;
      })
      .catch(err => {
        this.loadingContent = false;
        this.errorLoadingContent = true;
        this.ai.trackException('Error getting breaches list: ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting breaches list');
      })
  }

  private applyFilter(list: any) {
    const _keyword = this.searchKeyword.toLowerCase();
    const _b = list.filter((b: any) => {
      return (b.description.toLowerCase().indexOf(_keyword) >= 0
        || (b.legislation != null && b.legislation.toLowerCase().indexOf(_keyword) >= 0)
        || b.breachCode.toLowerCase().indexOf(_keyword) >= 0)
        && ((this.showRuleBreachesOnly && b.breachType.id == 1) || (this.showLawBreachesOnly && b.breachType.id == 2));
    })
    return _b;
  }

  private isDuplicated(refNumber: string): boolean {
    if (this.breaches == null || this.breaches.length == 0) return false;
    const _existingBreaches = this.breaches.filter((b: any) => {
      return b.refNumber == refNumber;
    })
    return _existingBreaches.length > 0;
  }

  private closeModal(): void {
    this.$emit('close');
  }

  private submit(): void {
    this.submitting = true;
    const _selectedBreaches = this.breachesListDisplay.filter((b: any) => b.isSelected);
    this.$emit('update:breaches', _selectedBreaches);
    this.$emit('addBreaches');
    // delay close to allow save action
    setTimeout(() => {
      this.closeModal();
    }, 500);
  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.breachesListDisplay.length > 0) {
          const nameSorter = index == 0 ? (c: any) => c.description.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.description.toLowerCase()];
          const orderByResults = orderBy(
            this.breachesListDisplay,
            nameSorter,
            [this.sortMethod as any]
          );
          this.breachesListDisplay = orderByResults;
        }
      }
    }
  }
}

